export default __webpack_public_path__ + "static/wall-photos-4ef4c2fe6eab8a67c2196cc691078af0.png";